import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { getUrl } from '@/common/oldMobile';
import { replaceNonAlpaNumeric } from '@/common/client';
import axios from 'axios';
import { catcher } from '@/_http/utils';

export const loadMarkdownInternalArticle = articleCode => db => {
    if (db.getIn(['cms', 'markdown', articleCode])) {
        return db;
    }
    axios
        .get(getUrl('MARKDOWN_INTERNAL_ARTICLE_BY_CODE'), {
            params: { code: articleCode }
        })
        .then(data => reframe.dispatch(markdownArticleLoaded({ [articleCode]: data.article })))
        .catch(catcher.handleMasterError);
    return db;
};

export const loadMarkdownMarketingArticle = (url, ignoreCache, isPromoPage) => db => {
    if (db.getIn(['cms', 'articles', url]) || db.getIn(['cms', 'markdown', url])) {
        return db;
    }
    axios
        .get(getUrl('MARKDOWN_MARKETING_ARTICLE_BY_URL'), {
            params: ignoreCache ? { url: url, ignoreCache: true } : { url: url }
        })
        .then(data =>
            isPromoPage
                ? reframe.dispatchSync(markdownArticleLoaded({ [url]: data.article }))
                : reframe.dispatch(markdownArticleLoaded({ [url]: data.article }))
        )
        .catch(catcher.handleMasterError);

    return db;
};

const markdownArticleLoaded = articles => db =>
    db.mergeIn(
        ['cms', 'markdown'],
        Immutable.Map(),
        Immutable.fromJS(articles || {}).map(value => (value === null ? Immutable.Map() : value))
    );

export const cmsSectionLoaded = (section, categories) => db =>
    db
        // set data for menu
        .setIn(
            ['cms', 'sections', section, 'menu'],
            categories.reduce(
                (result, category) => result.set(category.get('title'), category.get('articles')),
                Immutable.OrderedMap()
            )
        )
        // create map of article url -> article
        .setIn(
            ['cms', 'sections', section, 'articles'],
            categories.reduce(
                (articles, category) =>
                    articles.merge(
                        category
                            .get('articles')
                            .reduce(
                                (categoryArticles, article) =>
                                    categoryArticles.set(replaceNonAlpaNumeric(article.get('url')), article),
                                Immutable.Map()
                            )
                    ),
                Immutable.Map()
            )
        );
